import { Button } from '@/components/atoms/Button';
import { Card } from '@/components/atoms/Card';
import { Typography } from '@/components/atoms/Typography';
import { useTranslation } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

export interface WelcomeCardProps extends Omit<ViewProps, 'style'> {
    onRegisterPress?: (() => void) | undefined;
    onLoginPress?: (() => void) | undefined;
    style?: ViewProps['style'];
}

export const WelcomeCard = React.memo<WelcomeCardProps>(function WelcomeCard({
    onRegisterPress,
    onLoginPress,
    style,
    ...props
}) {
    const { t } = useTranslation();

    return (
        <Card
            variant="transparent"
            padding={32}
            style={[styles.card, style]}
            {...props}
        >
            {/* Welcome Text Section */}
            <View style={styles.textSection}>
                <View style={styles.titleSection}>
                    <Typography variant="body" color="white" style={styles.welcomeText}>
                        {t('welcome.welcomeTo')}
                    </Typography>
                    <Typography variant="title1" color="white" style={styles.appName}>
                        {t('welcome.appName')}
                    </Typography>
                </View>

                <Typography variant="body" color="white" style={styles.subtitle}>
                    {t('welcome.subtitle1')}
                </Typography>
                <Typography variant="body" color="white" style={styles.subtitle}>
                    {t('welcome.subtitle2')}
                </Typography>
            </View>

            {/* Buttons Section */}
            <View style={styles.buttonSection}>
                <Button
                    title={t('auth.register')}
                    variant="primary"
                    theme="dark"
                    fullWidth
                    onPress={onRegisterPress || undefined}
                />

                <Button
                    title={t('auth.login')}
                    variant="outline"
                    theme="dark"
                    fullWidth
                    onPress={onLoginPress || undefined}
                />
            </View>
        </Card>
    );
});

const styles = StyleSheet.create({
    card: {
        width: 345,
        alignSelf: 'center',
        marginHorizontal: 24,
    },
    textSection: {
        marginBottom: 48,
        alignItems: 'center',
    },
    titleSection: {
        marginBottom: 32,
        alignItems: 'center',
    },
    welcomeText: {
        textAlign: 'center',
        marginBottom: 8,
        fontSize: 20, // Larger than body for emphasis
    },
    appName: {
        textAlign: 'center',
        fontWeight: '500',
    },
    subtitle: {
        textAlign: 'center',
        opacity: 0.9,
    },
    buttonSection: {
        gap: 12,
    },
});

export default WelcomeCard;
